// extracted by mini-css-extract-plugin
export var page = "layout-module--page--MGrJ-";
export var layoutMain = "layout-module--layout-main--605Kj";
export var layoutContent = "layout-module--layout-content--wnHCM";
export var header = "layout-module--header--ho3hq";
export var content = "layout-module--content--TSzXv";